// JsFromRoutes CacheKey f59f49ce7cd07e8330db2d3944c54c97
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/matches'),
  create: /* #__PURE__ */ definePathHelper('post', '/matches'),
  new: /* #__PURE__ */ definePathHelper('get', '/matches/new'),
  show: /* #__PURE__ */ definePathHelper('get', '/matches/:id'),
}
